export default "__VITE_ASSET__B7cs8q5q__"